//find the enabled route to navigate to
export const getEnabledRoute = (premiumFeatures) =>{

  if(!premiumFeatures) return { path: "/premiumFeatures", isEnabled: true };

  return [
    { path: "/dashboard", isEnabled: premiumFeatures.isStaffHubDashboard === true },
    { path: "/residents", isEnabled: premiumFeatures.isStaffHubResidents === true },
    { path: "/family-members", isEnabled: premiumFeatures.isStaffHubResidents === true },
    { path: "/calendar", isEnabled: premiumFeatures.isStaffHubCalendar === true },
    { path: "/gallery", isEnabled: premiumFeatures.isStaffHubContentManagerGallery === true },
    { path: "/digital-signage", isEnabled: premiumFeatures.isStaffHubContentManagerDigitalSignage === true },
    { path: "/contentLibrary", isEnabled: premiumFeatures.isStaffHubContentManagerMediaLibrary === true },
    { path: "/lifestyle-programs", isEnabled: premiumFeatures.isStaffHubLifestylePrograms === true },
    { path: "/concierge-list", isEnabled: premiumFeatures.isStaffHubConcierge === true },
    { path: "/maintenanceRequests", isEnabled: premiumFeatures.isStaffHubMaintenance === true },
    { path: "/reports", isEnabled: premiumFeatures.isStaffHubReporting === true },
    { path: "/surveys", isEnabled: premiumFeatures.isStaffHubSurveys === true },
    { path: "/guestbook", isEnabled: premiumFeatures.isStaffHubGuestbook === true },
    { path: "/messaging", isEnabled: premiumFeatures.isStaffHubMessenger === true },
    { path: "/devices", isEnabled: true },
    { path: "/premiumFeatures", isEnabled: true }, // default route if no premium features are enabled (currently not used)

  ].find((route) => route.isEnabled);
  
}

export const getNextRouteData = (enabledRoutePath: string, to: any) =>{
  if(enabledRoutePath === to.path) {
    return { path: enabledRoutePath, query: { redirect: to.fullPath }}
  }
  else {
    return { path: enabledRoutePath}
  }
}